// @flow
import styled from 'styled-components';
import {ThankYouFloaterContent, ThankYouFloaterDisclaimer, ThankYouFloaterTitle, ThankYouFloater, UnderTopBarFloater} from "../../AppStyle";
import {styles} from "../../../config";



export const WelcomePageTitle = ThankYouFloaterTitle.extend`
    user-select: none;
    width: 90%;
    margin-bottom: 20px;
    white-space: pre-wrap;
`;

export const WelcomePageContent = ThankYouFloaterContent.extend`
    color: ${styles.primaryColor};
    font-weight: 300;
    font-size: 21px;
    line-height: 21px;
    white-space: pre-wrap;
    margin-top: 10px;
    margin-bottom: 10px;
    user-select: none;
`;

export const WelcomePageDisclaimer = ThankYouFloaterDisclaimer.extend`
    user-select: text;
    width: 90%;
    margin-bottom: 10px;
    white-space: pre-wrap;
`;

export const UnderTopBarWelcomeFloater = styled.div`
    ${ThankYouFloater};
    ${UnderTopBarFloater};
`;



// WEBPACK FOOTER //
// ./src/Components/Screen/WelcomePage/WelcomePageStyle.js